import Button from '@/components/Button';
import { FiChevronRight } from '@/components/react-icons/main';
import Toggle from '@/components/Toggle';

const WizardToggle = ({ canConfigure, active, onChange, disabled = false, title, description, button, configureButton }) => {
  return (
    <div className="comp-wizard-toggle" onClick={onChange}>
      {canConfigure && <Toggle size="sm" active={active} onChange={onChange} disabled={disabled} />}
      <div className="comp-wizard-toggle-main">
        <div className="comp-wizard-toggle-title">{title}</div>
        <div className="comp-wizard-toggle-description">{description}</div>
      </div>
      {!canConfigure && (
        <Button className="ghost medium negative-right" size="sm" icon={FiChevronRight} iconPosition="right" route={button?.route}>
          {button?.label}
        </Button>
      )}
      {canConfigure && active && configureButton && (
        <Button className="ghost medium negative-right" size="sm" onClick={configureButton.onClick}>
          {configureButton.label}
        </Button>
      )}
    </div>
  );
};

export default WizardToggle;
